{
	"navigation": {
		"moreLabel": "Další"
	},
	"useDeclarationCreationFormStore": {
		"errorMessages": {
			"fetchDefaultMaterial": "Materiál se nepodařilo načíst",
			"submitDeclaration": "Nepodařilo se odeslat prohlášení"
		}
	},
	"country": {
		"AC": "Ostrov Ascension",
		"AD": "Andorra",
		"AE": "Spojené arabské emiráty",
		"AF": "Afghánistán",
		"AG": "Antigua a Barbuda",
		"AI": "Anguilla",
		"AL": "Albánie",
		"AM": "Arménie",
		"AO": "Angola",
		"AQ": "Antarktida",
		"AR": "Argentina",
		"AS": "Americká Samoa",
		"AT": "Rakousko",
		"AU": "Austrálie",
		"AW": "Aruba",
		"AX": "Alandské ostrovy",
		"AZ": "Ázerbajdžán",
		"BA": "Bosna a Hercegovina",
		"BB": "Barbados",
		"BD": "Bangladéš",
		"BE": "Belgie",
		"BF": "Burkina Faso",
		"BG": "Bulharsko",
		"BH": "Bahrajn",
		"BI": "Burundi",
		"BJ": "Benin",
		"BL": "Svatý Bartoloměj",
		"BM": "Bermudy",
		"BN": "Brunej",
		"BO": "Bolívie",
		"BQ": "Karibské Nizozemsko",
		"BR": "Brazílie",
		"BS": "Bahamy",
		"BT": "Bhútán",
		"BV": "Bouvetův ostrov",
		"BW": "Botswana",
		"BY": "Bělorusko",
		"BZ": "Belize",
		"CA": "Kanada",
		"CC": "Kokosový ostrov",
		"CD": "Kongo DR",
		"CEFTA": "Cefta",
		"CF": "Středoafrická republika",
		"CG": "republika Kongo",
		"CH": "Švýcarsko",
		"CI": "Pobřeží slonoviny",
		"CK": "Cookovy ostrovy",
		"CL": "Chile",
		"CM": "Kamerun",
		"CN": "Čína",
		"CO": "Kolumbie",
		"CP": "Ostrov Clipperton",
		"CR": "Kostarika",
		"CU": "Kuba",
		"CV": "Cabo Verde",
		"CW": "Curaçao",
		"CX": "Vánoční ostrov",
		"CY": "Kypr",
		"CZ": "Česká republika",
		"DE": "Německo",
		"DG": "Diego Garcia",
		"DJ": "Džibutsko",
		"DK": "Dánsko",
		"DM": "Dominika",
		"DO": "Dominikánská republika",
		"DZ": "Alžírsko",
		"ES": "Španělsko",
		"EC": "Ekvádor",
		"EE": "Estonsko",
		"EG": "Egypt",
		"EH": "Západní Sahara",
		"ER": "Eritrea",
		"CT": "Katalánsko (Španělsko)",
		"PV": "Baskicko (Španělsko)",
		"ES-TR": "území Španělska",
		"ET": "Etiopie",
		"EU": "Evropská unie",
		"FI": "Finsko",
		"FJ": "Fidži",
		"FK": "Falklandské ostrovy",
		"FM": "Mikronésie",
		"FO": "Faerské ostrovy",
		"FR": "Francie",
		"GA": "Gabon",
		"ENG": "Anglie",
		"NIR": "Severní Irsko",
		"SCT": "Skotsko",
		"WLS": "Wales",
		"GB": "Velká Británie",
		"GD": "Grenada",
		"GE": "Gruzie",
		"GF": "Francouzská Guyana",
		"GG": "Guernsey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Grónsko",
		"GM": "Gambie",
		"GN": "Guinea",
		"GP": "Guadeloupe",
		"GQ": "Rovníková Guinea",
		"GR": "Řecko",
		"GS": "Jižní Georgie a Jižní Sandwichovy ostrovy",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bissau",
		"GY": "Guyana",
		"HK": "Hongkong",
		"HM": "Heardův ostrov a McDonaldovy ostrovy",
		"HN": "Honduras",
		"HR": "Chorvatsko",
		"HT": "Haiti",
		"HU": "Maďarsko",
		"IC": "Kanárské ostrovy",
		"ID": "Indonésie",
		"IE": "Irsko",
		"IL": "Izrael",
		"IM": "Ostrov Mann",
		"IN": "Indie",
		"IO": "Britské indickooceánské území",
		"IQ": "Irák",
		"IR": "Írán",
		"IS": "Island",
		"IT": "Itálie",
		"JE": "Trikot",
		"JM": "Jamaica",
		"JO": "Jordán",
		"JP": "Japonsko",
		"KE": "Keňa",
		"KG": "Kyrgyzstán",
		"KH": "Kambodža",
		"KI": "Kiribati",
		"KM": "Komory",
		"KN": "Svatý Kryštof a Nevis",
		"KP": "Severní Korea",
		"KR": "Jižní Korea",
		"KW": "Kuvajt",
		"KY": "Kajmanské ostrovy",
		"KZ": "Kazachstán",
		"LA": "Laos",
		"LB": "Libanon",
		"LC": "Svatá Lucie",
		"LI": "Lichtenštejnsko",
		"LK": "Srí Lanka",
		"LR": "Libérie",
		"LS": "Lesotho",
		"LT": "Litva",
		"LU": "Lucembursko",
		"LV": "Lotyšsko",
		"LY": "Libye",
		"MA": "Maroko",
		"MC": "Monako",
		"MD": "Moldavsko",
		"ME": "Černá Hora",
		"MF": "Svatý Martin",
		"MG": "Madagaskar",
		"MH": "Marshallovy ostrovy",
		"MK": "Severní Makedonie",
		"ML": "Mali",
		"MM": "Myanmar (Barma)",
		"MN": "Mongolsko",
		"MO": "Macao",
		"MP": "Severní Mariany",
		"MQ": "Martinik",
		"MR": "Mauritánie",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauricius",
		"MV": "Maledivy",
		"MW": "Malawi",
		"MX": "Mexiko",
		"MY": "Malajsie",
		"MZ": "Mosambik",
		"NA": "Namibie",
		"NC": "Nová Kaledonie",
		"NE": "Niger",
		"NF": "Ostrov Norfolk",
		"NG": "Nigérie",
		"NI": "Nikaragua",
		"NL": "Nizozemí",
		"NO": "Norsko",
		"NP": "Nepál",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "Nový Zéland",
		"OM": "Omán",
		"PA": "Panama",
		"PE": "Peru",
		"PF": "Francouzská Polynésie",
		"PG": "Papua Nová Guinea",
		"PH": "Filipíny",
		"PK": "Pákistán",
		"PL": "Polsko",
		"PM": "Saint Pierre a Miquelon",
		"PN": "Pitcairnovy ostrovy",
		"PR": "Portoriko",
		"PS": "Palestina",
		"PT": "Portugalsko",
		"PW": "Palau",
		"PY": "Paraguay",
		"QA": "Katar",
		"RE": "Shledání",
		"RO": "Rumunsko",
		"RS": "Srbsko",
		"RU": "Rusko",
		"RW": "Rwanda",
		"SA": "Saúdská Arábie",
		"SB": "Šalamounovy ostrovy",
		"SC": "Seychely",
		"SD": "Súdán",
		"SE": "Švédsko",
		"SG": "Singapur",
		"SH": "Svatá Helena Ascension a Tristan da Cunha",
		"SI": "Slovinsko",
		"SJ": "Svalbard a Jan Mayen",
		"SK": "Slovensko",
		"SL": "Sierra Leone",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somálsko",
		"SR": "Surinam",
		"SS": "Jižní Súdán",
		"ST": "Svatý Tomáš a Princův ostrov",
		"SV": "El Salvador",
		"SX": "Svatý Martin",
		"SY": "Sýrie",
		"SZ": "Svazijsko",
		"SZ-2": "Eswatini",
		"TA": "Tristan da Cunha",
		"TC": "Ostrov Turks a Caicos",
		"TD": "Čad",
		"TF": "Francouzské jižní a antarktické země",
		"TG": "Togo",
		"TH": "Thajsko",
		"TJ": "Tádžikistán",
		"TK": "Tokelau",
		"TL": "Východní Timor",
		"TM": "Turkmenistán",
		"TN": "Tunisko",
		"TO": "Tonga",
		"TR": "Turecko",
		"TT": "Trinidad a Tobago",
		"TV": "Tuvalu",
		"TW": "Tchaj-wan",
		"TZ": "Tanzanie",
		"UA": "Ukrajina",
		"UG": "Uganda",
		"US": "USA",
		"UN": "Spojené národy",
		"US-2": "NÁS",
		"UY": "Uruguay",
		"UZ": "Uzbekistán",
		"VA": "Vatikán",
		"VC": "Svatý Vincent a Grenadiny",
		"VE": "Venezuela",
		"VG": "Britské Panenské ostrovy",
		"VI": "Americké Panenské ostrovy",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis a Futuna",
		"WS": "Samoa",
		"XK": "Kosovo",
		"YE": "Jemen",
		"YT": "Mayotte",
		"ZA": "Jižní Afrika",
		"ZM": "Zambie",
		"ZW": "Zimbabwe"
	},
	"languages": {
		"bg-BG": "Bulharština",
		"cs-CZ": "Čeština",
		"de-DE": "Němčina",
		"en-US": "Angličtina",
		"el-GR": "Řečtina",
		"es-ES": "Španělština",
		"fr-FR": "Francouzština",
		"it-IT": "Italština",
		"nl-NL": "Nizozemština",
		"no-NO": "Norština",
		"pl-PL": "Polština",
		"ro-RO": "Rumunština",
		"sv-SE": "Švédština"
	},
	"traceIdBadge": {
		"traceIdLabel": "ID stopy"
	},
	"units": {
		"kg": "kg",
		"ton": "t",
		"m3": "M3",
		"co2": "CO\u2082 ekv.",
		"kgCO2": "kg CO\u2082 ekv."
	}
}
